import { render } from "./HistoryRestoreLoader.vue?vue&type=template&id=1d5719cc&scoped=true"
import script from "./HistoryRestoreLoader.vue?vue&type=script&lang=ts"
export * from "./HistoryRestoreLoader.vue?vue&type=script&lang=ts"

import "./HistoryRestoreLoader.vue?vue&type=style&index=0&id=1d5719cc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1d5719cc"

export default script